<template>
  <PayDialog @close="closeOrderDialog" :money="parseFloat(orderInfo.fee)" :tradeNo="tradeNo">
    <section class="order-dialog">
      <div class="left">支付订单</div>
      <div class="right">
        <div class="order-info">
          <div class="order-item"><span>作品名称</span><span>{{orderInfo.dubbing_name}}</span></div>
          <div class="order-item"><span>配音主播</span><span>{{orderInfo.speaker_name}}</span></div>
          <div class="order-item"><span>作品字数</span><span>{{orderInfo.text_len}}字</span></div>
          <div class="order-item"><span>商品价格</span><span>{{orderInfo.fee}}元</span></div>
          <div class="order-item"><span></span><span>小计<span class="highlight">￥{{orderInfo.fee}}</span></span></div>
        </div>
        <div class="price-info">
          <span @click="showDetail" class="price-button">计价说明<svg-icon name="down_arrow" :class="{
            'rotate-180': showPriceFlag,
            'rotate-0': !showPriceFlag,
          }"></svg-icon></span>
          <div class="price-list" v-show="showPriceFlag" >
            <div class="price-item" v-for="item, index in dubList" :key="index">
              <span>{{item.char_count_begin}}-{{item.char_count_end}}字</span><span>{{(item.money_num/100).toFixed(2)}}元</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </PayDialog>
</template>

<script>
import PayDialog from 'components/pay-dialog'
import {getStateDubPrice} from 'utils/model'

export default {
  name: 'order-dialog',
  props: {
    orderInfo: {
      type: Object,
      default: () => {}
    },
    path: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showPriceFlag: false,
      dubList: [],
      tradeNo: ''
    }
  },
  watch: {
    orderInfo (val) {
      this.tradeNo = val.trade_no
    }
  },
  components: {
    PayDialog
  },
  created() {
    this.getDubPrice()
  },
  methods: {
    async getDubPrice () {
      this.dubList = await getStateDubPrice()
      // console.log(res.data)
    },
    closeOrderDialog (type) {
      if (this.path === '/maker/create' && type === 'paid') {
        localStorage.setItem('dubbingParams', '')
      }
      this.$store.dispatch('global/setOrderFlag', false)
      this.tradeNo = ''
    },
    showDetail () {
      this.showPriceFlag = !this.showPriceFlag;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.order-dialog {
  display: flex;
  margin-bottom: 25px;
  .highlight {
    color: #F35456;
  }
  .left {
  }
  .right {
    flex: 1;
    margin: 0 30px;
    .order-info {
      .order-item {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
      }
    }
    .price-info {
      color: #999999;
      font-size: 14px;
      .price-button {
        cursor: pointer;
        display: inline-block;
      }
      .svg-icon {
        width: 17px;
        height: 10px;
        margin-left: 7px;
      }
      .price-list {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        background: #F9F9F9;
        padding: 8px 12px;
        flex-wrap: wrap;
        width: 400px;
        .price-item {
          width: 45%;
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
}
</style>
